import { useState } from 'react';
import { useCreateFiles } from '@tribeplatform/react-sdk/hooks';
import { mergeArrayByKey } from '../../common/utils/array.utils';
export const useHandleUploadableFiles = ({ defaultValue, multiple, onChange, onError, }) => {
    const { mutateAsync: createFiles, isLoading } = useCreateFiles({
        useMutationOptions: {
            onError,
        },
    });
    const [files, setFiles] = useState(defaultValue);
    const onFileUpload = async (newFiles) => {
        var _a, _b, _c, _d;
        // If not file, do nothing
        if (!(newFiles === null || newFiles === void 0 ? void 0 : newFiles.length))
            return null;
        if (!multiple) {
            newFiles = newFiles.slice(0, 1);
        }
        const tempFileData = newFiles.map(({ name, size }) => ({
            id: `${name}-${size}`,
            url: '',
            downloadUrl: '',
            size,
            extension: name.slice(name.lastIndexOf('.') + 1).toLowerCase(),
            name,
            isLoading: true,
        }));
        setFiles(files => multiple ? mergeArrayByKey(files, tempFileData, 'name') : tempFileData);
        try {
            const uploadedFiles = await createFiles(newFiles.map(file => {
                const { type, name, size } = file;
                return {
                    file,
                    contentType: type,
                    name,
                    extension: name.slice(name.lastIndexOf('.') + 1).toLowerCase(),
                    size,
                };
            }));
            const updatedFiles = multiple
                ? mergeArrayByKey(files, uploadedFiles, 'name')
                : uploadedFiles;
            setFiles(updatedFiles);
            onChange(updatedFiles);
        }
        catch (error) {
            // Revert back
            const updatedFiles = [...files.filter(a => !a.isLoading)];
            setFiles(updatedFiles);
            onChange(updatedFiles);
            const message = ((_d = (_c = (_b = (_a = error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.map(e => e.message)) === null || _d === void 0 ? void 0 : _d.join('\n')) || error.message;
            onError({
                fileName: '',
                message,
            });
        }
    };
    const onRemove = (file) => {
        const updatedFiles = [...files.filter(it => it.id !== file.id)];
        setFiles(updatedFiles);
        onChange(updatedFiles);
    };
    return {
        files,
        isLoading,
        onFileUpload,
        onRemove,
    };
};
//# sourceMappingURL=useHandleUploadableFiles.js.map